module.exports = __webpack_public_path__ + "img/8.155738d9.jpg";